
// 抛出一个函数
exports.install = function(Vue){
    Vue.prototype.getQueryVariable = function(name){
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    }
    
    
    // 获取今天、明天、后天的日期  传0为今天，1为明天，以此类推
    Vue.prototype.getDate = function(count){
        let dd = new Date();
        dd.setDate(dd.getDate() + count); // 获取 count 天后的日期
        let y = dd.getFullYear();
        let m = dd.getMonth() + 1;  // 获取当前月份的日期
        m = (m <= 9) ? '0' + m : m;
        let d = dd.getDate();
        d = (d <= 9) ? '0' + d : d;
        return this.dateTime = y + '-' + m + '-' + d;
    }
    
    // 获取指定日期为星期几
    Vue.prototype.getWeekDay = function(time){
        // console.log('已预约时间：',time)
        let date = new Date(time);
        let weekStr = '星期' + '日一二三四五六'[date.getDay()];
        let day = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) + '月' + date.getDate() + '日' : (date.getMonth() + 1) + '月' + date.getDate() + '日';
        let moment = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + '到店';
        return day + ' ' + weekStr + ' ' + moment;
    }
    
    
    // 检查手机号是否合法
    Vue.prototype.isMobileNumber = function(number){
        const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;  // 11位手机号码验证正则
        return reg_tel.test(number);
    }
    // 检查车牌号是否合法
    Vue.prototype.isCarNumValid = function(str){
        const reg_carNo = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
        return reg_carNo.test(str);
    }
    
}

